module.exports = __webpack_public_path__ + "static/img/online-order.b1fb4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/online-order.png
// module id = 9KMT
// module chunks = 1